import { gatewayService } from "@/_services/gateway.service";
/**
 * Exposure data, with Fwd Valuation
 * @param {string} _this: context variable
 * @param {boolean} daysToExpiration: Days to expiracion list
 */
export function readCurrencyValuationDataOptimizer(_this, daysToExpiration) {
  return gatewayService.currencies.valuationInputs({
    format: "json",
    currency: _this.currencyNumber,
    last: 1,
    days_to_expiration: JSON.stringify({ values: daysToExpiration }),
    observation_date: Date().toLocaleString()
  });
}
